import { render, staticRenderFns } from "./examShareDetail.vue?vue&type=template&id=2d69618e&scoped=true&"
import script from "./examShareDetail.vue?vue&type=script&lang=js&"
export * from "./examShareDetail.vue?vue&type=script&lang=js&"
import style0 from "./examShareDetail.vue?vue&type=style&index=0&id=2d69618e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d69618e",
  null
  
)

export default component.exports